export default "https://cdn-static.gokick.com/assets/f142aa9afb455fb94cf2718539e479c66bf8a410/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";